<template>
  <v-row class="video-modal" justify="center">
    <v-dialog width="1098" :value="true" @input="handleCloseModal">
      <v-card class="modal__card pa-6">
        <v-btn
          icon
          color="primary"
          class="float-right"
          @click="handleCloseModal"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-card-title class="modal__card-title px-0">
          <span>{{ title }}</span>
        </v-card-title>
        <v-card-text class="modal__card-description px-0">
          {{ description }}
        </v-card-text>
        <v-card-text class="px-0">
          <div id="player" class="plyr__video-embed">
            <iframe
              :src="`https://player.vimeo.com/video/${videoId}?loop=false&amp;byline=false&amp;portrait=false&amp;title=false&amp;speed=true&amp;transparent=0&amp;gesture=media`"
              allowfullscreen
              allowtransparency
              allow="autoplay"
            ></iframe>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Plyr from 'plyr';
import { SEGMENT_EVENTS } from '../../constants';

export default {
  name: 'VideoModal',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    videoId: {
      type: [String, Number],
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default: '',
    },
    sector: {
      type: String,
      default: '',
    },
    contentId: {
      type: [String, Number],
      default: null,
    },
  },
  data: () => ({
    played: false,
  }),
  created() {
    window.addEventListener('resize', this.resizeWindow);
  },
  destroyed() {
    window.removeEventListener('resize', this.resizeWindow);
  },
  mounted() {
    const player = new Plyr('#player', {
      invertTime: false,
    });

    player.on('play', () => {
      if (!this.played) {
        this.played = true;
        window.analytics.track(SEGMENT_EVENTS.WATCHED_VIDEO, {
          contentTitle: this.title,
          contentId: this.contentId,
          vimeoId: this.videoId,
          contentType: 'Video Tutorials',
        });
      }
    });

    setTimeout(() => {
      this.$nextTick(() => {
        this.resizeWindow();
      });
    }, 300);
  },
  methods: {
    resizeWindow() {
      const poster = document.getElementsByClassName('plyr__poster');
      const time = document.querySelector('.plyr__time');
      if (poster && poster[0] && time) {
        const node = poster[0];
        time.style.top = `${(node.offsetHeight - 105) * -1}px`;
        time.style.display = 'block';
      }
    },
    handleCloseModal() {
      window.analytics.track(SEGMENT_EVENTS.CLOSED_VIDEO_MODAL, {
        contentTitle: this.title,
        contentId: this.contentId,
        contentType: 'Video Tutorials',
      });
      this.$emit('close-modal');
    },
  },
};
</script>

<style scoped>
.video-modal {
  margin: 0;
}
.modal__chip-tag {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  letter-spacing: 0.1px;
  color: #91a092;
  height: 23px;
  background: #e6f5ed !important;
  border-radius: 4px;
}
.modal__text-tag {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.1px;
  color: var(--v-primary-base) !important;
}
.modal__card .modal__card-title {
  font-style: normal;
  font-weight: 500 !important;
  font-size: 20px !important;
  line-height: 24px;
  letter-spacing: 0.1px !important;
  text-transform: capitalize;
  color: #234025;
}
.modal__card .modal__card-description {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: 0.1px;
  color: #7b7d7a;
}
.modal__video {
  width: 100%;
}
video::-webkit-media-controls-panel {
  display: none !important;
  opacity: 1 !important;
}
.play-icon {
  float: left;
  position: relative;
  margin-top: -120px;
  margin-left: 20px;
}
</style>
